import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

/** Invite people to your communities (your states and LGAs): a link per place, copy or share it. */
export default class InviteModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.places = null;
    this.error = null;
    this.copied = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/voucha-community/invites',
      errorHandler: () => {}
    }).then(r => this.places = r.places).catch(e => this.error = e?.response?.message || "Couldn't load your communities.").finally(() => m.redraw());
  }
  className() {
    return 'InviteModal Modal--small';
  }
  title() {
    return 'Invite people to your community';
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.body());
  }
  body() {
    if (this.error) return m("p", {
      className: "InviteModal-error"
    }, this.error);
    if (!this.places) return m(LoadingIndicator, null);
    if (!this.places.length) return m("p", null, "Add a Nigerian state or LGA to My Community first, then you can invite people to it.");
    return m("div", null, m("p", {
      className: "InviteModal-intro"
    }, "Share a link with family, friends and neighbours. When they join, they'll be asked how they're connected to the place."), this.places.map(p => m("div", {
      className: "InviteModal-place"
    }, m("div", {
      className: "InviteModal-placeHead"
    }, m("strong", null, m("i", {
      className: p.place.type === 'lga' ? 'fas fa-map-pin' : 'fas fa-map'
    }), " ", p.place.name), p.joined ? m("span", {
      className: "InviteModal-joined"
    }, p.joined, " joined") : null), p.url ? this.shareRow(p) : m(Button, {
      className: "Button",
      onclick: () => this.create(p),
      loading: p.loading
    }, "Get invite link"))));
  }
  shareRow(p) {
    const text = 'Join Nigerians from ' + p.place.name + ' on Voucha';
    const enc = encodeURIComponent;
    return m("div", {
      className: "InviteModal-share"
    }, m("input", {
      className: "FormControl",
      readonly: true,
      value: p.url,
      onclick: e => e.target.select()
    }), m("div", {
      className: "InviteModal-buttons"
    }, m(Button, {
      className: "Button Button--primary",
      icon: this.copied === p.url ? 'fas fa-check' : 'fas fa-copy',
      onclick: () => this.copy(p.url)
    }, this.copied === p.url ? 'Copied' : 'Copy'), navigator.share ? m(Button, {
      className: "Button",
      icon: "fas fa-share-alt",
      onclick: () => navigator.share({
        title: text,
        text,
        url: p.url
      }).catch(() => {})
    }, "Share") : null, m("a", {
      className: "Button",
      href: 'https://wa.me/?text=' + enc(text + ': ' + p.url),
      target: "_blank",
      rel: "noopener",
      title: "WhatsApp"
    }, m("i", {
      className: "fab fa-whatsapp"
    })), m("a", {
      className: "Button",
      href: 'https://twitter.com/intent/tweet?text=' + enc(text) + '&url=' + enc(p.url),
      target: "_blank",
      rel: "noopener",
      title: "X"
    }, m("i", {
      className: "fab fa-x-twitter"
    })), m("a", {
      className: "Button",
      href: 'mailto:?subject=' + enc(text) + '&body=' + enc(text + ':\n' + p.url),
      title: "Email"
    }, m("i", {
      className: "fas fa-envelope"
    }))));
  }
  async create(p) {
    p.loading = true;
    try {
      const r = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/voucha-community/invites',
        body: {
          placeType: p.place.type,
          placeId: p.place.id
        },
        errorHandler: () => {}
      });
      Object.assign(p, r);
    } catch (e) {
      this.error = e?.response?.message || "Couldn't create the link.";
    }
    p.loading = false;
    m.redraw();
  }
  async copy(url) {
    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      const input = document.querySelector('.InviteModal-share input');
      if (input) {
        input.select();
        document.execCommand('copy');
      }
    }
    this.copied = url;
    m.redraw();
    setTimeout(() => {
      this.copied = null;
      m.redraw();
    }, 2000);
  }
}
flarum.reg.add('voucha-community', 'forum/components/InviteModal', InviteModal);